

import {
    createDefaultFilters,
    getFilterValue,
    setFilterValue,
    updateFilterOptions,
    clearAllFilters,
    getDateRangeFromFilters,
    getActiveFilters,
    safeJSONParse
  } from '../utils/filters.js';

  export function useFilters() {
    return {

      createFilters() {
        return createDefaultFilters();
      },

      getFilterValue(filters, key) {
        return getFilterValue(filters, key);
      },
  
      setFilterValue(filters, key, value) {
        setFilterValue(filters, key, value);
      },
  
      updateFilterOptions(filters, key, options, keepTodos = true) {
        updateFilterOptions(filters, key, options, keepTodos);
      },
  
      clearFilters(filters) {
        clearAllFilters(filters);
      },
  
      getDateRange(filters) {
        const filterValues = {
          year: getFilterValue(filters, 'year'),
          month: getFilterValue(filters, 'month'),
          day: getFilterValue(filters, 'day')
        };
        return getDateRangeFromFilters(filterValues);
      },
  
      getActiveFilters(filters) {
        return getActiveFilters(filters);
      },
  
      getCurrentSiteId($cookies) {
        const cookieSite = $cookies?.get('userInfo')?.currentSite || null;
        if (cookieSite) {
          if (typeof cookieSite === 'object' && cookieSite.id) return cookieSite.id;
          return cookieSite;
        }
        const storedSite = safeJSONParse(localStorage.getItem('currentSite')) || null;
        if (storedSite) {
          if (typeof storedSite === 'object' && storedSite.id) return storedSite.id;
          return storedSite;
        }
        return null;
      },
  
      buildRequestParams(siteId, filters) {
        const params = { SiteId: siteId };
        
        const dateRange = this.getDateRange(filters);
        if (dateRange) {
          params.StartDate = dateRange.StartDate;
          params.EndDate = dateRange.EndDate;
        }
        
        return params;
      }
    };
  }
  
  export const FiltersMixin = {
    methods: {
      ...useFilters()
    }
  };